"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var component_nav_container_1 = __importDefault(require("./component.nav-container"));
var component_nav_menu_1 = __importDefault(require("./component.nav-menu"));
var NavLink = function (props) { return (jsx_runtime_1.jsx("li", __assign({}, props, { className: "nav-item mx-3 " + props.className }, { children: props.children }), void 0)); };
var Navigation = function (props) {
    var _a = props.height, height = _a === void 0 ? 100 : _a, imgURL = props.imgURL, _b = props.color, color = _b === void 0 ? 'dark' : _b, _c = props.bg, bg = _c === void 0 ? 'transparent' : _c, _d = props.open, open = _d === void 0 ? false : _d, _e = props.className, className = _e === void 0 ? '' : _e;
    var css = {
        NavContainer: "text-" + color + " bg-" + bg + " " + className,
        NavMenu: "bg-" + color,
    };
    return (jsx_runtime_1.jsxs(component_nav_container_1.default, __assign({ height: height, className: css.NavContainer }, { children: [jsx_runtime_1.jsx("nav", __assign({ className: "navbar navbar-toggleable-sm" }, { children: jsx_runtime_1.jsxs("div", __assign({ className: "container" }, { children: [jsx_runtime_1.jsx("a", __assign({ className: "navbar-brand mr-auto " + (open ? 'd-none' : 'd-block'), href: "/" }, { children: imgURL && (jsx_runtime_1.jsx("img", { className: "mr-2", height: height < 30 ? 30 : height, src: imgURL, alt: "logo" }, void 0)) }), void 0),
                        jsx_runtime_1.jsx("div", __assign({ className: "" + (open ? 'd-md-none m-auto' : 'd-none d-md-block') }, { children: jsx_runtime_1.jsx("ul", __assign({ className: "navbar-nav" }, { children: props.children }), void 0) }), void 0)] }), void 0) }), void 0),
            jsx_runtime_1.jsx("div", __assign({ id: "nav-menu-toggle", onClick: function () { return props.toggle(!open); } }, { children: jsx_runtime_1.jsx(component_nav_menu_1.default, { height: height, open: open, className: css.NavMenu }, void 0) }), void 0)] }), void 0));
};
exports.Navigation = Navigation;
exports.Navigation.Link = NavLink;
exports.Navigation.Menu = component_nav_menu_1.default;
exports.Navigation.Container = component_nav_container_1.default;
//# sourceMappingURL=index.js.map